import { PAGE_API_QUERY_KEY_HEAD } from '@Core/clients/pageApiQueryKeys';
import { createApi } from '@Pages/pageRuntime/sdk/api';
import { toApiError } from '@Pages/pageRuntime/sdk/apiErrors';
import type { SdkPayerBalances, SdkPayerBalancesOptions } from '@Pages/pageRuntime/sdk/types';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

const NO_BALANCES: SdkPayerBalances['balances'] = [];

export function usePayerBalances({
  resourceId,
  recordId,
  enabled = true
}: SdkPayerBalancesOptions): SdkPayerBalances {
  const canRead = enabled && resourceId.length > 0 && recordId.length > 0;
  const query = useQuery<Diagonal.Core.Data.PayerBalancesData, ReturnType<typeof toApiError>>({
    queryKey: [PAGE_API_QUERY_KEY_HEAD, 'records', resourceId, recordId, 'payer-balances'],
    enabled: canRead,
    retry: false,
    throwOnError: false,
    queryFn: async ({ signal }) => {
      return createApi(axios).get<Diagonal.Core.Data.PayerBalancesData>(
        `/api/data/resources/${encodeURIComponent(resourceId)}/records/${encodeURIComponent(recordId)}/payer-balances`,
        { signal }
      );
    }
  });
  const data = canRead && !query.isError ? query.data : undefined;

  return {
    balances: data?.balances ?? NO_BALANCES,
    total: data?.total ?? null,
    isLoading: canRead && query.isLoading,
    error: canRead ? query.error : null,
    refetch: async () => {
      if (canRead) {
        await query.refetch();
      }
    }
  };
}
